import { Grid } from "@mui/material";

import HTMLRenderer from "components/common/HTMLRenderer";
import RichText from "components/common/RichText";
import Typography from "components/common/Typography";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { setPayloadData } from "../PlanAssignment.slice";
import "./index.scss";

const MessageToAssignee = (props: any) => {
  const dispatch = useAppDispatch();

  const {
    payloadData: { plans, message }
  } = useAppSelector((state) => state.PlanAssignment);

  return (
    <div className="assignment_details-message">
      <Typography showBold variant={"body2"} color={tokens.Text.General.Secondary}>
        Message to Plan Members
      </Typography>
      {props.isMessageEditable && (
        <Typography variant="body2" color={tokens.Text.General.Secondary}>
          Write a custom message to assigned Plan Members to help them understand the purpose and priority of this
          shared Plan.{" "}
        </Typography>
      )}
      <Grid item width={"100%"}>
        {props.isMessageEditable ? (
          <RichText
            minHeight="237px"
            placeholder="Enter your custom message here."
            initialValue={message}
            handleChangeUpdate={(message) => dispatch(setPayloadData({ message }))}
          />
        ) : (
          <Grid
            item
            width={"100%"}
            padding={"10px 20px"}
            borderRadius={"12px"}
            border={`1px solid ${tokens.Border.General.Tertiary}`}
            marginBottom="16px"
          >
            <HTMLRenderer content={message} />
          </Grid>
        )}
      </Grid>
    </div>
  );
};

export default MessageToAssignee;
